var map = {
	"./futureCreateWork.js": "2917",
	"./futureEdu.js": "7c18",
	"./futureHealth.js": "5797",
	"./futureNeighbourhood.js": "5f51",
	"./futureService.js": "7943",
	"./futureTransport.js": "b851",
	"./futureTreat.js": "ef54",
	"./healthHourse.js": "9214",
	"./other.js": "d8c7",
	"./rubbishSort.js": "d473"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "264d";